import { REGIONS } from '@/data'
import type { SectionsSchema } from '@/types/components/SectionsProps'

const REGIONS_ARRAY = Object.values(REGIONS) as string[]

export const getFallbackRegionsByRegion = (region: string): string[] => {
  const baseLanguage = region.split('-')[0]
  const country = region.split('-')[1]?.toUpperCase()
  const fallbackRegions: string[] = []

  if (REGIONS_ARRAY.includes(region)) fallbackRegions.push(region)

  // If not English, first try English in same country
  if (country && baseLanguage !== 'en') {
    const countryEnglish = `en-${country.toLowerCase()}`
    if (REGIONS_ARRAY.includes(countryEnglish)) fallbackRegions.push(countryEnglish)
  }

  if (REGIONS_ARRAY.includes(REGIONS.EN_US) && !fallbackRegions.includes(REGIONS.EN_US)) {
    fallbackRegions.push(REGIONS.EN_US)
  }

  return fallbackRegions
}

export const getEnabledRegionOrFallback = (region: string, enabledRegions: string[]): string | null => {
  const slugifiedEnabledRegions = enabledRegions?.map(r => r.replace('_', '-')) || []
  // Check if current region is enabled
  if (slugifiedEnabledRegions.includes(region)) return region

  // Try each fallback region in order
  const fallbacks = getFallbackRegionsByRegion(region)
  const enabledFallback = fallbacks.find(fallbackRegion => enabledRegions?.includes(fallbackRegion))
  if (enabledFallback) return enabledFallback

  return null
}

export const getSectionsByFallbackRegions = (sections: Record<string, SectionsSchema> | undefined, fallbackRegions: string[], region: string): SectionsSchema | null => {
  if (!sections) return null

  if (sections[region]) {
    return sections[region]
  }

  for (const fallbackRegion of fallbackRegions) {
    if (sections[fallbackRegion]) {
      return sections[fallbackRegion]
    }
  }

  return null
}
